



















































/**
 * https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
 */

import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class ConfirmDelete extends Vue {
  @Prop({ default: "Confirm Delete" }) title!: string;
  @Prop({ default: "Are you sure you want to remove this item?" })
  message!: string;
  @Prop({ default: "Remove" }) confirmLabel!: string;

  protected closeModal(): void {
    this.$emit("close");
  }
}
